import type { SomethingWithState } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export enum ArtilleryAimState {
	STAGE1 = "STAGE1",
	STAGE2 = "STAGE2",
}

export class ArtilleryAimIndicator extends PhysicalThing implements SomethingWithState {
	static key = "ArtilleryAimIndicator";
	private state: ArtilleryAimState = ArtilleryAimState.STAGE1;

	constructor(xy: XY) {
		super(xy, false);
	}

	override getZOrder(): number {
		return ZOrder.AIR;
	}

	override isTangible(): boolean {
		return false;
	}

	getState(): ArtilleryAimState {
		return this.state;
	}

	setState(state: ArtilleryAimState): void {
		this.state = state;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			state: this.state,
		};
	}

	static deserialize(data: any): ArtilleryAimIndicator {
		const a = new ArtilleryAimIndicator(deserializeXY(data.xy));
		a.visualId = data.visualId;
		a.state = data.state ?? ArtilleryAimState.STAGE1;
		return a;
	}
}
